export default __webpack_public_path__ + "static/gaming_plan-e9b4b011df15b8963d016729893bc388.jpeg";